<template>
  <div @click="visible = true">
    <slot></slot>
    <a-modal
      v-model="visible"
      width="80vw"
      :footer="null"
      :centered="true"
      :closable="false"
      :maskClosable="false"
      :maskStyle="{ background: '#1c1c1c' }"
      wrapClassName="c-led-converter-modal"
    >
      <div class="c-led-converter">
        <img ref="cropper" :src="image" class="cropper" />
        <label v-if="!image" class="cropper-upload" for="upload">
          <div class="upload-box">
            <i class="iconfont iconupload-folder" />
          </div>
          <span v-html="$t('light.supportFormat', ['40*5'])"></span>
          <input
            id="upload"
            type="file"
            @change="onUpload"
            :value="image"
            accept="image/gif, image/png, image/jpeg"
            multiple="multiple"
          />
        </label>
        <div class="buttons" v-if="image">
          <md-button class="button" @click="image = null">
            {{ $t("back") }}
          </md-button>
          <md-button class="button" v-if="image" @click="onConversion">
            {{ $t("conversion") }}
          </md-button>
        </div>
        <i class="close iconfont iconclose-o" @click="visible = false" />
      </div>
    </a-modal>
  </div>
</template>
<script>
import Cropper from "cropperjs";
import GifFrames from "gif-frames";
import "cropperjs/dist/cropper.css";

export default {
  name: "CLedConverter65GameBoy",
  data() {
    return {
      visible: false,
      image: null,
      cropper: null,
    };
  },
  methods: {
    onUpload(e) {
      const files = e.target.files;
      for (let index = 0; index < files.length; index++) {
        const file = files[index];
        setTimeout(() => {
          if (file && file.type.includes("image/")) {
            if (file.type === "image/gif") {
              this.buildFrames(file);
            } else {
              const image = new Image();
              image.src = URL.createObjectURL(file);
              image.onload = () => {
                if (image.width / image.height === 8) {
                  const canvas = document.createElement("canvas");
                  const context = canvas.getContext("2d");
                  canvas.width = image.width;
                  canvas.height = image.height;
                  context.drawImage(image, 0, 0, image.width, image.height);
                  this.$emit("change", { RGB: this.getRGB(canvas) });
                  this.visible = false;
                } else {
                  this.image = URL.createObjectURL(file);
                }
              };
            }
          } else {
            e.target.value = null;
            this.$message.info(this.$t("light.fileErrorInfo"));
          }
        }, index * 1000);
      }
    },
    onConversion() {
      const canvas = this.cropper.getCroppedCanvas({
        minWidth: 40,
        minHeight: 5,
      });
      this.$emit("change", { RGB: this.getRGB(canvas) });
      this.visible = false;
    },
    getRGB(canvas) {
      const { width, height } = canvas;
      const context = canvas.getContext("2d");
      const imageData = context.getImageData(0, 0, width, height);
      const ratio = width / 40;
      let RGB = [];

      for (let j = 0; j < 5; j++) {
        for (let i = 0; i < 40; i++) {
          // let index = (j * 40 + i) * 4;
          let index =
            Math.floor(
              Math.floor((j + 0.5) * ratio) * 40 * ratio +
                Math.floor((i + 0.5) * ratio)
            ) * 4;
          index = index - (index % 4);
          index =
            index >= imageData.data.length ? imageData.data.length - 4 : index;
          let r = imageData.data[index].toString(16);
          let g = imageData.data[index + 1].toString(16);
          let b = imageData.data[index + 2].toString(16);
          r = (r.length === 1 ? "0" : "") + r;
          g = (g.length === 1 ? "0" : "") + g;
          b = (b.length === 1 ? "0" : "") + b;
          RGB.push("#" + r + g + b);
        }
      }
      return RGB;
    },
    buildFrames(file) {
      this.$message.info(this.$t("light.build"), 60000);
      GifFrames({
        url: URL.createObjectURL(file),
        frames: "all",
        outputType: "canvas",
      })
        .then((frameData) => {
          let frames = [];
          const canvas = document.createElement("canvas");
          const context = canvas.getContext("2d");
          canvas.width = 120;
          canvas.height = 15;
          const width = frameData[0].getImage().width;
          const height = (width * canvas.height) / canvas.width;
          const sy = (frameData[0].getImage().height - height) / 2;
          frameData.map((item) => {
            context.drawImage(
              item.getImage(),
              0,
              sy,
              width,
              height,
              0,
              0,
              canvas.width,
              canvas.height
            );
            frames.push({
              frame_index: frames.length + 1,
              frame_RGB: this.getRGB(canvas),
            });
          });
          this.$emit("change", { frames });
          this.$message.destroy();
          this.visible = false;
        })
        .catch(() => {
          this.$message.destroy();
        });
    },
  },
  watch: {
    image(image) {
      if (image) {
        setTimeout(() => {
          this.cropper = new Cropper(this.$refs.cropper, {
            viewMode: 1,
            dragMode: "move",
            aspectRatio: 8,
            minCropBoxWidth: 40,
            background: false,
            toggleDragModeOnDblclick: false,
          });
        });
      } else {
        this.cropper && this.cropper.destroy();
      }
    },
  },
  mounted() {
    window.addEventListener("resize", () => {
      this.cropper && this.cropper.destroy();
      this.image = null;
    });
  },
};
</script>
<style lang="scss" scoped>
.c-led-converter {
  @include flex-center;
  width: 1250px;
  height: 800px;
  flex-direction: column;
  margin: 0 auto;
  position: relative;

  .cropper {
    width: 100%;
    height: 100%;
    visibility: hidden;
  }

  .cropper-container {
    .cropper-view-box {
      outline: 2px solid $primary-color;
    }
    .cropper-modal {
      opacity: 0.25;
    }
    .cropper-point,
    .cropper-line {
      background-color: $primary-color;
    }
  }

  .cropper-upload {
    @include flex-center;
    width: 100%;
    flex-direction: column;
    position: absolute;
    top: 350px;
    left: 0;
    cursor: pointer;

    .upload-box {
      @include flex-center;
      width: 800px;
      height: 100px;
      border: 2px solid $primary-color;
      color: $primary-color;
      margin-bottom: 20px;

      i {
        font-size: 60px;
      }
    }

    input {
      display: none;
    }

    span {
      color: #ffffff;
      font-size: 20px;
    }
  }

  .buttons {
    @include flex-center;
    width: 100%;
    position: absolute;
    bottom: 100px;
    left: 0;

    .button {
      width: 450px;
      height: 53px;
      background-color: $primary-color;
      border-radius: 5px;
      font-size: 20px;
      text-transform: none;

      & + .button {
        margin-left: 100px;
      }
    }
  }

  .close {
    @include icon-hover;
    font-size: 40px;
    position: absolute;
    bottom: 30px;
    left: 50%;
    transform: translateX(-50%);
  }
}
</style>
